import React from 'react';
import { motion } from 'framer-motion';
import EclairFooterCredit from './EclairFooterCredit';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Inicio', id: 'home' },
    { name: 'Nosotros', id: 'about' },
    { name: 'Beneficios', id: 'benefits' },
    { name: 'Planes', id: 'services' },
    { name: 'Pagos', id: 'payment' },
    { name: 'Contacto', id: 'contact' }
  ];

  const socialLinks = [
    { name: 'Facebook', icon: '📱', url: 'https://www.facebook.com/profile.php?id=61580383047370' },
    { name: 'Instagram', icon: '📸', url: 'https://instagram.com/oec.sv' },
    { name: 'TikTok', icon: '🎥', url: 'https://tiktok.com/@oec.sv' },
    { name: 'WhatsApp', icon: '📲', url: 'https://wa.me/50364376585' }
  ];

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="col-span-1"
          >
            <div className="mb-4">
              <img src="/set/1.png" alt="OEC Logo" className="h-24 w-auto" />
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Aprende inglés desde donde estés
            </p>
            <div className="text-sm text-gray-400">
              <p>📧 oeccorporate@gmail.com</p>
              <p>📱 WhatsApp: +503 6437 6585</p>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="col-span-1"
          >
            <h4 className="text-lg font-semibold mb-4 text-yellow-primary">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <motion.button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-300 hover:text-white transition-colors duration-300 text-left"
                    whileHover={{ x: 5 }}
                  >
                    {link.name}
                  </motion.button>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="col-span-1"
          >
            <h4 className="text-lg font-semibold mb-4 text-yellow-primary">Nuestros Planes</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Clases Grupales</li>
              <li>Clases de Conversación</li>
              <li>Clases Personalizadas</li>
              <li>TOEIC Prep Course</li>
            </ul>
          </motion.div>

          {/* Social Media */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="col-span-1"
          >
            <h4 className="text-lg font-semibold mb-4 text-yellow-primary">Síguenos</h4>
            <div className="flex space-x-4">
              <motion.a
                href="https://wa.me/50364376585"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.9 }}
              >
                <img src="/set/7.png" alt="WhatsApp" className="w-8 h-8" />
              </motion.a>
              <motion.a
                href="https://instagram.com/oec.sv"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.9 }}
              >
                <img src="/set/8.png" alt="Instagram" className="w-8 h-8" />
              </motion.a>
              <motion.a
                href="https://www.facebook.com/profile.php?id=61580383047370"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.9 }}
              >
                <img src="/set/9.png" alt="Facebook" className="w-8 h-8" />
              </motion.a>
              <motion.a
                href="mailto:oeccorporate@gmail.com"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.9 }}
              >
                <img src="/set/10.png" alt="Email" className="w-8 h-8" />
              </motion.a>
              <motion.a
                href="https://tiktok.com/@oec.sv"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.9 }}
              >
                <img src="/set/11.png" alt="TikTok" className="w-8 h-8" />
              </motion.a>
            </div>
            <p className="text-gray-400 text-sm mt-4">
              ¡Únete a nuestra comunidad para tips diarios de inglés e inspiración!
            </p>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="border-t border-gray-700 mt-12 pt-8 text-center"
        >
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} OEC - Online English Classes. Todos los derechos reservados.
            </p>
          </div>

          <motion.div
            className="mt-6 text-center"
            whileHover={{ scale: 1.05 }}
          >
            <p className="text-sm text-gray-500">
              🌟 Transformando vidas a través de la educación en inglés desde 2022 🌟
            </p>
          </motion.div>

          <motion.div
            className="mt-4 text-center"
            whileHover={{ scale: 1.02 }}
          >
            <EclairFooterCredit />
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;